export class TrackingModel {
    name: string;
    id: string;
}